export class StopMileageResponse {
  shipmentIdentifier?: number;
  originSequenceNumber?: number;
  destinationSequenceNumber?: number;
  mileage?: number;

  constructor(opts?: Partial<StopMileageResponse>) {
    if (opts?.shipmentIdentifier != null) {
      this.shipmentIdentifier = opts.shipmentIdentifier;
    }
    if (opts?.originSequenceNumber != null) {
      this.originSequenceNumber = opts.originSequenceNumber;
    }
    if (opts?.destinationSequenceNumber != null) {
      this.destinationSequenceNumber = opts.destinationSequenceNumber;
    }
    if (opts?.mileage != null) {
      this.mileage = opts.mileage;
    }
  }
}
